import { backofficeRequest } from '../../axios'

export default class Athome {
  /**
   * Synchronise les recipients depuis l'API Athome et met à jour la DB
   * @param {number} orderId - ID de la commande Athome
   * @returns {Promise} Liste des recipients mis à jour
   */
  async syncRecipients(orderId) {
    try {
      return await backofficeRequest.get(
        `athome/orders/${orderId}/recipients/sync`
      )
    } catch (error) {
      return error.response
    }
  }

  /**
   * Récupère la preuve de dépôt d'un recipient en base64
   * @param {number} recipientId - ID du recipient
   * @returns {Promise} Objet contenant la preuve en base64 {depositProof: string}
   */
  async getDepositProof(recipientId) {
    try {
      return await backofficeRequest.get(
        `athome/recipients/${recipientId}/deposit-proof`
      )
    } catch (error) {
      return error.response
    }
  }
}
